import routes from 'js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { ClaimCitation } from './types';

type ClaimCitationsResponse = {
  citations: ClaimCitation[];
};

export const getClaimCitations = async (
  workId: number,
): Promise<ClaimCitationsResponse> => {
  const response = await fetchWithCsrf(
    routes.citations_api_v0_work_path({
      id: workId,
      subdomain_param: 'api',
    }),
    { method: 'GET' },
  );

  if (!response.ok) {
    throw new Error('Failed to load citations');
  }

  return (await response.json()) as ClaimCitationsResponse;
};
